import React, { useEffect, useRef, useState } from "react";
import "../dashboard.scss";
import { AgGridReact } from "ag-grid-react";
import { academylist, expenditurecreate, expendituredelete, expenditurelist, expenditureview } from "../../../services/admin";
import { useLocation, useNavigate } from "react-router-dom";
import { incexplist } from "../../../services/master";
import { Col, Modal, Row } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export default function Addincome() {
    const [filterProduct, setFilterProduct] = useState([]);
    const [catid, setCatID] = useState(0);
    const [head, setHead] = useState("");
    const [name, setName] = useState("");
    const [invno, setInvNo] = useState("");
    const [idate, setIDate] = useState("");
    const [amt, setAmt] = useState("");
    const [iefile, setIEFile] = useState("");
    const [ieurl, setIEUrl] = useState("");
    const [desc, setDesc] = useState("");

    const [hlist, setHList] = useState([]);

    const [alist, setAList] = useState([]);
    const [acaid, setAcaID] = useState("");
    const [acid, setAcID] = useState("");

    const [errorMessage, setErrorMessage] = useState("");

    const location = useLocation();
    const [urllink, setUrllink] = useState("");

    const columnDefs = [
        {
            headerName: "Actions",
            width: 100,
            field: "id",
            resizable: true,
            filter: false,
            suppressCsvExport: true,

            // headerClass: "ag-center-aligned-header",
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a
                            onClick={() => viewshow(params.value)}
                            className="btn-sm btn-info me-2"
                        >
                            <i className="fa fa-edit"></i>
                        </a>
                        <a
                            onClick={() => expdelete(params.value)}
                            className="btn-sm btn-danger"
                        >
                            <i className="fa fa-trash"></i>
                        </a>
                    </div>
                );
            },
        },
        {
            headerName: "Income Head",
            field: "head_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Name",
            field: "name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Invoice",
            field: "inv_no",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Date",
            field: "inv_date",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },

        },
        {
            headerName: "Amount",
            field: "amount",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Description",
            field: "description",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Attachment",
            field: "attachment",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== "") {
                    return (
                        <div className="text-center">
                            <a
                                href={params.data.path + params.value}
                                target="_blank"
                                className="btn-sm btn-info me-2"
                            >
                                <i className="fa fa-download"></i>
                            </a>
                        </div>
                    );
                }

            },
             valueGetter: function (params) {
                const value = params.data?.attachment;
                const path = params.data?.path;

                return value && path ? `${path}${value}` : "";
            },
            
        },
        {
            headerName: "Academy",
            field: "academy_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

    ];
    const navigate = useNavigate();
    function deletelist() {
        if (urllink === "addincome") {
            navigate("/incomeandexpense/deleteincome");
        } else if (urllink === "addexpenses") {
            navigate("/incomeandexpense/deleteexpenses");
        }
    }
    const [show, setShow] = useState(false);
    function handleshow() {
        if (localStorage.getItem("AAcademy") != null) {
            academylist().then((res) => {
                if (res.status === true) {
                    let arr = [];
                    if (res.data.details.length > 0) {
                        for (let i = 0; i < res.data.details.length; i++) {
                            if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                                arr.push({
                                    value: res.data.details[i].id,
                                    label:
                                        res.data.details[i].name + " - " + res.data.details[i].code,
                                });
                            }
                            if (arr.length > 0) {
                                setAcaID(arr[0]);
                            }
                        }

                    }
                }
            });
        }
        setCatID(0);
        setHead("");
        setName("");
        setInvNo("");
        if (localStorage.getItem("ADate") !== '') {
            setIDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
        } else {
            setIDate(moment(new Date()).format("YYYY-MM-DD"));
        }
        setAmt("");
        setIEFile("");
        setIEUrl("");
        setDesc("");
        setErrorMessage("");
        setShow(true);
    }

    function handleclose() {
        setAcaID("");
        setCatID(0);
        setHead("");
        setName("");
        setInvNo("");
        if (localStorage.getItem("ADate") !== '') {
            setIDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
        } else {
            setIDate(moment(new Date()).format("YYYY-MM-DD"));
        }
        setAmt("");
        setIEFile("");
        setIEUrl("");
        setDesc("");
        setErrorMessage("");
        setShow(false);
    }

    function viewshow(vid) {
        setCatID(vid);
        setAcaID("");
        setHead("");
        setName("");
        setInvNo("");

        if (localStorage.getItem("ADate") !== '') {
            setIDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
        } else {
            setIDate(moment(new Date()).format("YYYY-MM-DD"));
        }
        setAmt("");
        setIEFile("");
        setIEUrl("");
        setDesc("");
        setShow(true);

        setErrorMessage("");
        expenditureview(vid).then((response) => {
            if (response.status === true) {
                setHead(response.data.details.head_id);
                setName(response.data.details.name);
                setInvNo(response.data.details.inv_no);
                setIDate(response.data.details.inv_date);
                setAmt(response.data.details.amount);
                setDesc(response.data.details.description);
                if (response.data.details.attachment !== null) {
                    setIEUrl(response.data.path + response.data.details.attachment);
                }
                academylist().then((res) => {
                    if (res.status === true) {
                        let arr = [];
                        if (res.data.details.length > 0) {
                            for (let i = 0; i < res.data.details.length; i++) {
                                if (res.data.details[i].id === response.data.details.academy_id) {
                                    arr.push({
                                        value: res.data.details[i].id,
                                        label:
                                            res.data.details[i].name + " - " + res.data.details[i].code,
                                    });
                                }
                            }
                            setAcaID(arr[0]);
                        }
                    }
                });
            }
        });
    }

    function expdelete(vid) {
        Swal.fire({
            text: "Are you sure want to Delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ac0404",
            cancelButtonColor: "#6259ca",
            confirmButtonText: "Delete",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {

                expendituredelete(vid).then((response) => {
                    if (response.status === true) {
                        funlist(acaid, urllink);
                    }
                });
            }
        });
    }

    useEffect(() => {
        const path = location.pathname.split("/")[2];
        setUrllink(path);


        academylist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].name + " - " + res.data.details[i].code,
                        });
                    }
                    setAList(arr);
                }
            }
        });
        if (localStorage.getItem("AAcademy") != null) {
            academylist().then((res) => {
                if (res.status === true) {
                    let arr = [];
                    if (res.data.details.length > 0) {
                        for (let i = 0; i < res.data.details.length; i++) {
                            if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                                arr.push({
                                    value: res.data.details[i].id,
                                    label:
                                        res.data.details[i].name + " - " + res.data.details[i].code,
                                });
                            }
                            if (arr.length > 0) {
                                setAcID(arr[0]);
                                funlist(arr[0], path);
                                listall(arr[0], path);
                            }
                        }

                    }
                }
            });
        } else {
            funlist("", path);
            listall("", path);
        }
    }, [location.pathname]);

    function funlist(fid, ltype) {
        setFilterProduct([]);
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && fid !== "") {
            temp.append("academy_id", fid.value);
        }
        if (ltype === "addincome") {
            temp.append("head_type", 1);
        } else if (ltype === "addexpenses") {
            temp.append("head_type", 2);
        }

        expenditurelist(temp).then((res) => {
            if (res.status === true) {
                // setFilterProduct(res.data.details);
                if (res.data.details.length > 0) {
                    const hdata = res.data.details.map((item) => {
                        return {
                            ...item,
                            inv_date: moment(item.inv_date).format("DD-MM-YYYY"),
                        };
                    });
                    setFilterProduct(hdata);
                }
            }
        });
    }

    function listall(fid, ltype) {
        setHead("");
        setHList([]);
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && fid !== "") {
            temp.append("academy_id", fid.value);
        }
        if (ltype === "addincome") {
            temp.append("type", 1);
            incexplist(temp).then((res) => {
                if (res.status === true) {
                    // setHList(res.data);
                    const hdata = res.data.filter((item) => item.active == 1);
                    setHList(hdata);
                }
            });
        } else if (ltype === "addexpenses") {
            temp.append("type", 2);
            incexplist(temp).then((res) => {
                if (res.status === true) {
                    // setHList(res.data);
                    const hdata = res.data.filter((item) => item.active == 1);
                    setHList(hdata);
                }
            });
        }
    }

    function handleAcad(e) {
        if (e !== null) {
            setAcID(e);
            funlist(e, urllink);
        } else {
            setAcID("");
            funlist("", urllink);
        }
    }

    function handleAcademy(e) {
        if (e !== null) {
            setAcaID(e);
            listall(e, urllink);
        } else {
            setAcaID("");
            listall("", urllink);

        }
    }

    const handleChange = (e) => {
        const regex = /^[0-9\b]+$/;
        if (e.target.value === "" || regex.test(e.target.value)) {
            setAmt(e.target.value);
        }
    };

    const [photoerror, setPhotoError] = useState("");
    function photofile(event) {
        setPhotoError("");
        setIEFile("");
        if (event.target.files.length !== 0) {
            if (event.target.files[0].name.match(/\.(jpg|jpeg|png|pdf)$/i)) {
                setIEFile(event.target.files[0]);
            } else {
                setPhotoError("Attachment should be jpg, jpeg, png or pdf format");
            }
            var size = event.target.files[0].size / 1024 / 1024;
            if (size > 5) {
                setPhotoError("Attachment size should be less than 5MB");
            }
        }
    }

    function submitincexp(e) {
        e.preventDefault();
        setErrorMessage("");
        let valid = "";
        if (localStorage.getItem("Role") === "1" && acaid === "") {
            valid = "Please Select Academy";
            setErrorMessage(valid);
        }
        if (valid === "") {
            if (head !== "") {
                if (name !== "") {
                    if (idate !== "") {
                        if (amt !== "") {
                            const temp = new FormData();
                            temp.append("head_id", head);
                            temp.append("name", name);
                            temp.append("inv_no", invno);
                            temp.append("inv_date", idate);
                            temp.append("amount", amt);
                            temp.append("attachment", iefile);
                            if (urllink === "addincome") {
                                temp.append("head_type", 1);
                            } else if (urllink === "addexpenses") {
                                temp.append("head_type", 2);
                            }
                            temp.append("description", desc);

                            if (localStorage.getItem("Role") === "1" && acaid !== "") {
                                temp.append("academy_id", acaid.value);
                            }
                            if (catid !== 0) {
                                temp.append("id", catid);

                            }
                            expenditurecreate(temp).then((response) => {
                                if (response.status === true) {
                                    handleclose();
                                    funlist(acaid, urllink);
                                    toast.success(response.message);
                                } else {
                                    setErrorMessage(response.message);
                                }
                            })
                        } else {
                            setErrorMessage("Please Enter Amount");
                        }
                    } else {
                        setErrorMessage("Please Select Date");
                    }
                } else {
                    setErrorMessage("Please Enter Name");
                }
            } else {
                if (urllink === "addincome") {
                    setErrorMessage("Please Select Income Head");

                } else if (urllink === "addexpenses") {
                    setErrorMessage("Please Select Expense Head");

                }
            }
        }
    }
    const gridRef = useRef();
    const exportToCSV = () => {
    const exportColumns = gridRef.current.columnApi
        .getAllGridColumns()
        .filter(col => !col.getColDef().suppressCsvExport)
        .map(col => col.getColId());

    gridRef.current.api.exportDataAsCsv({
        fileName: urllink === "addincome" ? 'Income List.csv' : 'Expenses List.csv',
        columnKeys: exportColumns,
        processCellCallback: (params) => {
            if (params.column.getColId() === "attachment") {
                const photoUrl = params.value;
                return photoUrl ? `=HYPERLINK("${photoUrl}", "View Attachment")` : '';
            }
            return params.value;
        },
    });
};

    return (
        <div>
            <div className="page-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">{urllink === "addincome" ? "Add Income" : "Add Expense"}</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a>Income and Expenses</a></li>
                        <li className="breadcrumb-item active" aria-current="page">{urllink === "addincome" ? "Add Income" : "Add Expense"}</li>
                    </ol>
                </div>
            </div>
            <div className="content-body">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h2 className="main-content-title tx-24 mg-b-5">
                                {urllink === "addincome" ? "Add Income" : "Add Expense"}
                            </h2>{" "}
                        </div>
                        <div className="card-body">


                            {localStorage.getItem("Role") === "1" && (
                                <div className="row">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="form-label">
                                            <label className="mb-2">
                                                Select Academy
                                                <span className="text-danger"> *</span>

                                            </label>
                                        </div>
                                        <Select
                                            className="default-select"
                                            placeholder="Select Academy"
                                            value={acid}
                                            options={alist}
                                            onChange={handleAcad}
                                            isSearchable={true}
                                            isClearable
                                            hidden
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="res-right">
                                            <a
                                                onClick={handleshow}
                                                variant="success"
                                                type="button"
                                                className="btn my-5 btn-success tx-teko me-2"
                                            >
                                                {" "}
                                                Add
                                            </a>
                                            <a onClick={deletelist}
                                                variant="success"
                                                type="button"
                                                className="btn my-5 btn-danger tx-teko me-2"
                                            >
                                                Delete List
                                            </a>
                                            <a onClick={exportToCSV}
                                                variant="secondary"
                                                type="button"
                                                className="btn my-5 btn-secondary tx-teko"
                                            >
                                                Download Excel
                                            </a>
                                        </div>
                                    </div>
                                </div>


                            )}

                            {localStorage.getItem("Role") !== "1" && (
                                <div className="responsive">
                                    <div className="res-right">
                                        <a
                                            onClick={handleshow}
                                            variant="success"
                                            type="button"
                                            className="btn my-1 me-2 btn-success tx-teko"
                                        >
                                            {" "}
                                            Add
                                        </a>
                                    </div>
                                </div>

                            )}



                            <div className="ag-theme-alpine ag-style">
                                <AgGridReact
                                    ref={gridRef}
                                    columnDefs={columnDefs}
                                    rowData={filterProduct}
                                    pagination="true"
                                    paginationPageSize="10"
                                    sortingOrder={["asc", "desc"]}
                                    suppressDragLeaveHidesColumns={true}
                                />
                            </div>
                            <Modal show={show}>
                                <Modal.Header>
                                    {urllink === "addincome" && catid === 0 ?
                                        <h4>Add Income</h4> :
                                        urllink === "addexpenses" && catid === 0 ?
                                            <h4>Add Expense</h4> :
                                            urllink === "addincome" && catid !== 0 ?
                                                <h4>Income Detail</h4> :
                                                urllink === "addexpenses" && catid !== 0 &&
                                                <h4>Expense Detail</h4>
                                    }

                                </Modal.Header>
                                <Modal.Body>
                                    <Row className="row-sm mx-0">
                                        {localStorage.getItem("Role") === "1" && (
                                            <Col lg={12} md={12}>
                                                <div className="form-label">
                                                    <label className="mb-2">
                                                        Select Academy
                                                        <span className="text-danger"> *</span>

                                                    </label>
                                                </div>
                                                <Select
                                                    className="default-select"
                                                    placeholder="Select Academy"
                                                    value={acaid}
                                                    options={alist}
                                                    onChange={handleAcademy}
                                                    isSearchable={true}
                                                    isClearable
                                                    hidden
                                                />

                                            </Col>
                                        )}

                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    {urllink === "addincome" ? "Income Head" : "Expense Head"} <span className="text-danger"> *</span>
                                                </label>
                                            </div>
                                            <div className="form-group">
                                                <select
                                                    className="form-control"
                                                    value={head}
                                                    onChange={(e) => setHead(e.target.value)}
                                                >
                                                    <option value="">Select {urllink === "addincome" ? "Income Head" : "Expense Head"}</option>
                                                    {hlist.map((item, index) => (
                                                        <option key={index} value={item.id}>
                                                            {item.head_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>

                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Name <span className="text-danger"> *</span>
                                                </label>
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Name"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                />
                                            </div>
                                        </Col>

                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Invoice Number
                                                </label>
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Invoice Number"
                                                    value={invno}
                                                    onChange={(e) => setInvNo(e.target.value)}
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Date <span className="text-danger"> *</span>
                                                </label>
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    placeholder="Enter Date"
                                                    value={idate}
                                                    onChange={(e) => setIDate(e.target.value)}
                                                />
                                            </div>
                                        </Col>

                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Amount <span className="text-danger"> *</span>
                                                </label>
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Amount"
                                                    value={amt}
                                                    maxLength={10}
                                                    onChange={handleChange}
                                                    onPaste={(e) => {
                                                        e.preventDefault();
                                                        return false;
                                                    }}
                                                    onCopy={(e) => {
                                                        e.preventDefault();
                                                        return false;
                                                    }}
                                                />
                                            </div>
                                        </Col>



                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Description
                                                </label>
                                            </div>
                                            <div className="form-group">
                                                <textarea
                                                    rows="3"
                                                    placeholder="Enter Description"
                                                    value={desc}
                                                    onChange={(e) => setDesc(e.target.value)}
                                                />
                                            </div>
                                        </Col>

                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Attachment
                                                </label>
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    onChange={photofile}
                                                    accept=".jpg, .jpeg, .png, .pdf"
                                                />
                                                {photoerror !== "" && (
                                                    <span className="text-danger">{photoerror}</span>
                                                )}
                                            </div>
                                        </Col>
                                        {catid !== 0 && ieurl !== "" && (
                                            <Col lg={12} md={12}>
                                                <div className="form-group">
                                                    {ieurl.split('.').pop() === "pdf" ? (
                                                        <a href={ieurl} target="_blank">
                                                            <img src={require('../../../assets/images/pdf.png')} width="100px" height="100px" />

                                                        </a>
                                                    ) : (
                                                        <img src={ieurl} width="100px" height="100px" />)

                                                    }
                                                </div>
                                            </Col>
                                        )

                                        }

                                        {errorMessage !== "" && (
                                            <span className="text-danger">{errorMessage}</span>
                                        )}
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    {catid === 0 ? (
                                        <a
                                            onClick={submitincexp}
                                            className="btn btn-next btn-success"
                                            style={{ float: "right" }}
                                        >
                                            Submit
                                        </a>
                                    ) : (
                                        <a
                                            onClick={submitincexp}
                                            className="btn btn-next btn-success"
                                            style={{ float: "right" }}
                                        >
                                            Update
                                        </a>
                                    )}
                                    <a
                                        className="btn btn-next btn-secondary"
                                        style={{ float: "right" }}
                                        onClick={handleclose}
                                    >
                                        Close
                                    </a>
                                </Modal.Footer>
                            </Modal>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}
